/**
 * Created by caiyuhao on 2017/1/31.
 */
export const getLoading = ({ base }) => base.isLoading
export const getDirection = ({ base }) => base.direction
export const getChina = ({ base }) => base.china
export const isSetting = ({ base }) => base.issetting

// TEST
export const getAD = ({ test }) => test.ad
export const getList = ({ test }) => test.list
export const getShopList = ({ test }) => test.shop
export const getShopFooter = ({ test }) => test.footer



// WEBPACK FOOTER //
// ./src/vuex/getters.js